import { render, staticRenderFns } from "./CallInfoModalNew.vue?vue&type=template&id=40d189c4&"
import script from "./CallInfoModalNew.vue?vue&type=script&lang=js&"
export * from "./CallInfoModalNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports